import { useNavigate } from 'react-router-dom'
import { EyeIcon } from '@heroicons/react/24/outline'
export default function ViewButton({ redirectPath }) {
  const navigate = useNavigate()
  return (
    <button
      onClick={() => navigate(redirectPath)}
      className="bg-secondary-600 text-white rounded-[4px] w-[101px] h-[30px] flex items-center justify-center gap-2 text-[16px] font-medium"
    >
      <EyeIcon className="w-5 h-5" />
      View
    </button>
  )
}
